/* eslint-disable */
import CServRedirectComp from './ServRedirectComp'
import QServRedirectComp from './QServRedirectComp'
import TServRedirectComp from './TServRedirectComp'
import MServRedirectComp from './MServRedirectComp'
import CServRedPacketComp from './TServRedPacketComp'
import QServRedPacketComp from './QServRedPacketComp'
import TServRedPacketComp from './TServRedPacketComp'
import MServRedPacketComp from './MServRedPacketComp'
import QServPrizeComp from './QServPrizeComp'
import TServPrizeComp from './TServPrizeComp'
import MServPrizeComp from './MServPrizeComp'
import CServHouseComp from './TServHouseComp'
import QServHouseComp from './QServHouseComp'
import TServHouseComp from './TServHouseComp'
import MServHouseComp from './MServHouseComp'
import QServFilterTabComp from './QServFilterTabComp'
import TServFilterTabComp from './TServFilterTabComp'
import TServTopListComp from './TServTopListComp'
import QServTopListComp from './QServTopListComp'
import MServTopListComp from './MServTopListComp'
import TServCommodityComp from './TServCommodityComp'
import QServCommodityComp from './QServCommodityComp'
import TServLandlordStoryComp from './TServLandlordStoryComp'
import QServLandlordStoryComp from './QServLandlordStoryComp'
import TServHouseFilterComp from './TServHouseFilterComp'
import QServHouseFilterComp from './QServHouseFilterComp'

export default {
  CServRedirectComp,
  QServRedirectComp,
  TServRedirectComp,
  MServRedirectComp,
  CServRedPacketComp,
  QServRedPacketComp,
  TServRedPacketComp,
  MServRedPacketComp,
  QServPrizeComp,
  TServPrizeComp,
  MServPrizeComp,
  CServHouseComp,
  QServHouseComp,
  TServHouseComp,
  MServHouseComp,
  QServFilterTabComp,
  TServFilterTabComp,
  TServTopListComp,
  QServTopListComp,
  MServTopListComp,
  TServCommodityComp,
  QServCommodityComp,
  TServLandlordStoryComp,
  QServLandlordStoryComp,
  TServHouseFilterComp,
  QServHouseFilterComp
}
